<template>
    <div>
        <p v-if="shouldShowNoAvailableFiltersText(filter)">{{ filter.noAvailableFiltersText }}</p>

        <label-filter-value
            v-for="filterValue in mainFilterValues"
            :key="filterValue.value"
            v-model="selectedFilterValues"
            :filter-value="filterValue"
        />

        <template v-if="otherFilterValues.length">
            <v-btn
                class="my-2 px-1 font-weight-regular"
                color="rgba(0, 0, 0, 0.6)"
                text
                @click="showAllFilterValues = !showAllFilterValues"
            >
                <span class="fl-all-filter-values">{{ $t(showAllFilterValues ? 'collapseSelect' : 'expandSelect') }}</span>
                <v-icon right>{{ showAllFilterValues ? mdiMinus : mdiPlus }}</v-icon>
            </v-btn>

            <v-expand-transition>
                <div v-if="showAllFilterValues">
                    <label-filter-value
                        v-for="filterValue in otherFilterValues"
                        :key="filterValue.value"
                        :filter-value="filterValue"
                        v-model="selectedFilterValues"
                    />
                </div>
            </v-expand-transition>
        </template>
    </div>
</template>
<script lang="ts">
import { mdiCheckboxBlankOutline, mdiCheckboxOutline } from '@mdi/js';
import { Vue } from 'vue-property-decorator';
import { Filter, FilterMetadata } from '../../../../../declarations/result';
import LabelFilterValue from './LabelFilter/LabelFilterValue.vue';
import TextFilterMixin from './TextFilterMixin.vue';

export default Vue.extend({
    name: 'LabelFilter',
    components: { LabelFilterValue },
    mixins: [TextFilterMixin],
    computed: {
        mainFilterValues(): FilterMetadata[] {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            const filter = this.filter as Filter;

            return filter.pinnedFilterValueCount < filter.values.length
                ? filter.values.slice(0, filter.pinnedFilterValueCount)
                : filter.values;
        },
        otherFilterValues(): FilterMetadata[] {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore TS does not recognize this value provided by the mixin, but WebStorm and the tests do. Fix later.
            const filter = this.filter as Filter;

            return filter.pinnedFilterValueCount < filter.values.length ? filter.values.slice(filter.pinnedFilterValueCount) : [];
        },
    },
    data() {
        return {
            mdiCheckboxBlankOutline,
            mdiCheckboxOutline,
        };
    },
});
</script>

<style lang="scss" scoped>
.fl-all-filter-values {
    letter-spacing: normal;
    text-transform: none;
}
</style>
